var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 0.833252C7.18817 0.833252 0.833008 7.18842 0.833008 14.9999C0.833008 22.8114 7.18817 29.1666 14.9997 29.1666C22.8112 29.1666 29.1663 22.8114 29.1663 14.9999C29.1663 7.18842 22.8112 0.833252 14.9997 0.833252ZM14.9997 6.49992C17.408 6.49992 19.2497 8.34159 19.2497 10.7499V12.1666C20.0997 12.1666 20.6663 12.7333 20.6663 13.5833V19.2499C20.6663 20.0999 20.0997 20.6666 19.2497 20.6666H10.7497C9.89968 20.6666 9.33301 20.0999 9.33301 19.2499V13.5833C9.33301 12.7333 9.89968 12.1666 10.7497 12.1666V10.7499C10.7497 8.34159 12.5913 6.49992 14.9997 6.49992ZM14.9997 8.62492C13.8663 8.62492 12.8747 9.61659 12.8747 10.7499V12.1666H14.9997H17.1247V10.7499C17.1247 9.61659 16.133 8.62492 14.9997 8.62492ZM14.9997 14.9999C14.624 14.9999 14.2636 15.1492 13.9979 15.4149C13.7323 15.6805 13.583 16.0409 13.583 16.4166C13.583 16.7923 13.7323 17.1526 13.9979 17.4183C14.2636 17.684 14.624 17.8333 14.9997 17.8333C15.3754 17.8333 15.7357 17.684 16.0014 17.4183C16.2671 17.1526 16.4163 16.7923 16.4163 16.4166C16.4163 16.0409 16.2671 15.6805 16.0014 15.4149C15.7357 15.1492 15.3754 14.9999 14.9997 14.9999Z",
    fill: "#E8361E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.ef9e2a2f4d737f333cc550c4ee477659.svg";
export { ForwardRef as ReactComponent };